import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Component, OnInit, Inject } from '@angular/core';

import { AlertType } from '../../enums';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent implements OnInit {
  alertType!: AlertType | string;
  link!: string;
  linkDescription!: string;
  description!: string;
  title!: string;
  isHtml!: string;

  constructor(private snackBar: MatSnackBar,  @Inject(MAT_SNACK_BAR_DATA) public data: any) {
       this.alertType = data.alertType as AlertType;
       this.title = data.title;
       this.link = data.link?.link;
       this.linkDescription = data.link?.linkDescription;
       this.description = data.description;
       this.isHtml = data.isHtml;

   }

  ngOnInit(): void {
  }
  close(): void {
    this.snackBar.dismiss();
  }
}
